import { ApiService } from "@/services/ApiService";
import { useEffect, useState } from "react";
import Table from "@/components/Table";
import { t } from "i18next";
import { useAuth } from "@/contexts/Auth";
import { checkHasPermission } from "@/lib/permissions";
import { useNavigate } from "react-router-dom";

const Users = () => {
  const [apiData, setApiData] = useState<any>([]);
  const { get } = ApiService;
  const { usuario } = useAuth();
  const navigate = useNavigate();

  const columns = [
    {
      header: t("table.profile.head.name"),
      accessor: "nome",
    },
    {
      header: t("table.profile.head.perms"),
      accessor: "permissoes",
    },
  ];

  const allowedActions = [];
  if (checkHasPermission(usuario?.permissoes, "ROLE_PERFIL_EDITAR")) {
    allowedActions.push("editar");
  }
  if (checkHasPermission(usuario?.permissoes, "ROLE_PERFIL_DELETAR")) {
    allowedActions.push("remover");
  }
  if (checkHasPermission(usuario?.permissoes, "ROLE_PERFIL_LISTAR")) {
    allowedActions.push("permissao");
  }

  const canAddNewProfile = checkHasPermission(usuario?.permissoes, "ROLE_PERFIL_REGISTRAR");


  useEffect(() => {
    const fetch = async () => {
      const { data } = await get("api/v1/perfil/listar");
      setApiData(data);
    };

    fetch();
  }, []);

  return (
    <div className="flex-1 overflow-hidden p-8 max-md:px-4">
      <div className="mb-8 border-b pb-4">
        <h1 className='text-3xl font-medium mb-8'>{t("profilePage.title")}</h1>
      </div>
      {apiData && (
        <Table
          entity="perfil"
          baseRoute="api/v1/perfil"
          allowedActions={allowedActions}
          search={true}
          columns={columns}
          defaultData={apiData}
          buttonLabel={t("table.profile.btn.add")}
          onButtonClick={() => navigate("registrar-perfil")}
          isButtonDisabled={!canAddNewProfile}
        />
      )}
    </div>
  );
};

export default Users;
